import axios from "axios"
import { env } from "../constants"

export const list = token => {
    const uri = `${env.startpoint}favorites`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.get(uri, headers).then(response => response).catch(error => error.response)
}

export const add = (token, id) => {
    const uri = `${env.startpoint}favorites/${id}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, {}, headers).then(response => response).catch(error => error.response)
}

export const remove = (token, id) => {
    const uri = `${env.startpoint}favorites/${id}`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.delete(uri, headers).then(response => response).catch(error => error.response)
}
